<template>
    <section class="content" style="background-color: #EBECF1">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-info">
                    <div class="box-header">
                        <!--- <h3 class="fuente box-title p-t-10">APLICACIÓN: {{ nombreAppFil }} ROL: {{ descripcionRol }}</h3> --->                        
                        <h3 class="fuente box-title p-t-10">{{ nombreAppFil }}: {{ descripcionRol }}</h3>
                        <h3 class="fuente box-title p-t-2">(APLICACIÓN: ROL)</h3>
                    </div>
                    <div class="box-body">
                        <form role="form">
                            <div class="row">
                                <div class="fuente col-xs-12 table-responsive">
                                    <div class="box-body">
                                        <table aria-describedby="tablaDetalle_info" role="grid" id="tablaDetalle"
                                            class="fuente fs-12 table table-bordered table-striped dataTable">
                                            <thead>
                                                <tr role="row">
                                                    <th aria-label="ITEM" aria-sort="ascending"
                                                        aria-controls="tablaDetalle" tabindex="0"
                                                        class="sorting_asc table-center-header">ITEM</th>
                                                    <th aria-label="URL" aria-controls="tablaDetalle" tabindex="0"
                                                        class="sorting">TRABAJADOR</th>
                                                    <th aria-label="ESTADO" aria-controls="tablaDetalle" tabindex="0"
                                                        class="sorting table-center-header">ESTADO
                                                    </th>
                                                    <th aria-label="ANULAR / AGREGAR" aria-controls="tablaDetalle"
                                                        tabindex="0" class="sorting table-center-header">
                                                        ANULAR  <span class="badge bg-red">X</span> / AGREGAR <span
                                                            class="badge bg-blue"><i class="fa fa-check"
                                                                aria-hidden="true"></i></span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="even" role="row" v-for="(item, index) in trabsOrder"
                                                    :key="index">
                                                    <td class="sorting_1 table-center-header">{{ index + 1 }}</td>
                                                    <td>{{ item.nombres }} {{ item.apePaterno }} {{ item.apeMaterno }}
                                                    </td>
                                                    <!--- <td><span style="cursor:pointer" class="badge bg-blue"
                                                            data-toggle="modal" @click="ver(item)"
                                                            data-target="#modalNuevo">O</span></td> --->
                                                    <td class="table-center-header">
                                                        <span
                                                            v-if="ususByRol.length > 0 && ususByRol.some(us => us.idUsuario === item.idUsuario)">
                                                            SI </span>
                                                        <span v-else> NO </span>
                                                    </td>
                                                    <td class="table-center-header">
                                                        <span
                                                            v-if="ususByRol.length > 0 && ususByRol.some(us => us.idUsuario === item.idUsuario)"
                                                            style="cursor:pointer" class="badge bg-red"
                                                            data-toggle="modal" @click="verAnular(item)"
                                                            data-target="#modalAnular">X
                                                        </span>
                                                        <span v-else style="cursor:pointer" class="badge bg-blue"
                                                            data-toggle="modal" @click="ver(item)"
                                                            data-target="#modalAgregar">
                                                            <i class="fa fa-check" aria-hidden="true"></i>
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="fuente col-md-12" style="color: red;">
                                        {{ error.desError }}
                                    </div>
                                </div>
                            </div>
                            <div class="modal fade" id="modalAnular" tabindex="-1" role="dialog"
                                aria-labelledby="myModalLabel">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <form>
                                            <div class="modal-header">
                                                <button type="button" class="close" data-dismiss="modal"
                                                    aria-label="Close"><span aria-hidden="true">X</span></button>
                                                <h4 class="fuente modal-title m-t-10" id="myModalLabel">¿DESEA ANULAR EL
                                                    TRABAJADOR DE ESTE ROL?</h4>
                                            </div>
                                            <div class="fuente modal-body">
                                                Se anulará de este rol a: {{ trab.nombres }} {{ trab.apePaterno }} {{
                            trab.apeMaterno }}
                                            </div>
                                            <div class="modal-footer">
                                                <button type="button" class="fuente btn btn-danger fs-13"
                                                    @click="merge()" data-dismiss="modal">Anular</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="modal fade" id="modalAgregar" tabindex="-1" role="dialog"
                                aria-labelledby="myModalLabel">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <form>
                                            <div class="modal-header">
                                                <button type="button" class="close" data-dismiss="modal"
                                                    aria-label="Close"><span aria-hidden="true">X</span></button>
                                                <h4 class="fuente modal-title m-t-10" id="myModalLabel">{{ texto }}</h4>
                                            </div>
                                            <div class="fuente modal-body">
                                                Se agregará a este rol a: {{ trab.nombres }} {{ trab.apePaterno }} {{
                                                trab.apeMaterno }}
                                            </div>
                                            <div class="modal-footer">
                                                <button type="button" class="fuente btn btn-primary fs-13"
                                                    @click="merge()" data-dismiss="modal">
                                                    Agregar</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import 'datatables.net'
import 'datatables.net-bs'
import axios from 'axios'
import $ from 'jquery'
import { apiURL } from '@/store/state'
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
//import App from '../App.vue';
import App from '@/components/App.vue';
import moment from 'moment';

export default {
    name: 'Tables',
    data() {
        return {
            texto: '',
            error: {
                desError: ''
            },
            idRol: localStorage.getItem('rol_idRol'),
            descripcionRol: localStorage.getItem('rol_descripcionRol'),
            idAppFil: localStorage.getItem('rol_idApp'),
            nombreAppFil: localStorage.getItem('rol_nombreApp'),
            trabs: [],
            ususByRol: [],
            trabsOrder: [],
            rols: [],
            trab: {
                idTrabajador: '0',
                nombres: '',
                apePaterno: '',
                apeMaterno: '',
                dni: '',
                cargo: '',
                correo: '',
                sigla: '',
                fecha_nac: new Date(),
                idAppXUsu: '0',
                idUsuario: '0',
                nomUsuario: '',
                flagActivo: '1',
                usuario: this.$session.get('user')
            },
            rolByUsu: {
                idRol: this.idRol,
                idUsuario: '0',
                idApp: '1',
                flagActivo: '1',
                idRolXUsu: '0',
                usuario: this.$session.get('user')
            },
            tiempoActual: null,
            tiempoTokenExp: null,
        }
    },    
    mounted() {
        //console.log('idRol', this.idRol)                       
        //this.tiempoActual = new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' });        
        //this.tiempoTokenExp = localStorage.getItem('TokenExpirationTime')
        this.tiempoActual = moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a");
        this.tiempoTokenExp = moment(localStorage.getItem('TokenExpirationTime'), "D/M/YYYY, h:mm:ss a");
        
        if (!this.$session.exists('token')) {
            App.methods.logout.call(this);
            return;
        }

        if (this.tiempoActual < this.tiempoTokenExp) {
            if (this.idRol && this.descripcionRol && this.idAppFil && this.nombreAppFil) {
                this.carga()
            }
            else {
                //this.$router.push('/home');
                this.$router.go(-1);
            }
        } else {
            this.alertaError401();
        }
    },
    methods: {
        carga() {
            // Destruir la instancia DataTable si ya existe
            const dataTableInstance = $('#tablaDetalle').DataTable();
            if (dataTableInstance) {
                dataTableInstance.destroy();
            }

            axios.defaults.headers.common['Authorization'] = this.$session.get('token')
            axios.get(
                `${apiURL}/usuarios/trabajadores/` + this.idAppFil
            ).then(response => {
                this.trabs = response.data
                //console.log('this.trabs', this.trabs)

                axios.defaults.headers.common['Authorization'] = this.$session.get('token')
                axios.get(
                    `${apiURL}/operaciones/usuByRol/` + this.idRol + '/' + this.idAppFil
                ).then(response => {
                    this.ususByRol = response.data
                    //console.log('--- ususByRol--:', this.ususByRol);

                    this.trabsOrder = this.trabs.sort((a, b) => {
                        // Verificamos si a y b tienen un rol en ususByRol
                        const aTieneRol = this.ususByRol && this.ususByRol.some(us => us.idUsuario === a.idUsuario);
                        const bTieneRol = this.ususByRol && this.ususByRol.some(us => us.idUsuario === b.idUsuario);
                        // Aplicamos la lógica de orden
                        if (aTieneRol && !bTieneRol) {
                            return -1; // a va antes que b
                        } else if (!aTieneRol && bTieneRol) {
                            return 1; // b va antes que a
                        } else {
                            return 0; // Mantenemos el orden original
                        }
                    });

                    this.$nextTick(() => {
                        $('#tablaDetalle').DataTable({
                            stateSave: true, // Guarda el estado y la paginación de la tabla
                            'stateSaveParams': function (settings, data) {
                                data.length = 25; // Establece la longitud de la página
                            },
                            //lengthMenu: [10, 25, 50, 100], // Definir las opciones de registros por página
                            pageLength: 25, // Establecer el número de registros por página al iniciar
                            'oLanguage': {
                                'sSearch': 'Buscar',
                                'sInfo': 'Mostrando _START_ al _END_ de _TOTAL_ registros',
                                'sEmptyTable': 'Sin Data',
                                'sZeroRecords': 'No se encontraron coincidencias',
                                'sInfoFiltered': '(filtrado de un total de _MAX_ registros)',
                                'sLengthMenu': '_MENU_ Registros por página',
                                'sInfoEmpty': 'Mostrando 0 al 0 de 0 registros',
                                'oPaginate': {
                                    'sPrevious': 'Anterior',
                                    'sNext': 'Siguiente'
                                }
                            }
                        })
                    })
                })
                    .catch(error => {
                        if (error.response && error.response.status === 401) {
                            App.methods.logout.call(this);
                        }
                    })
            })
                .catch(error => {
                    if (error.response && error.response.status === 401) {
                        App.methods.logout.call(this);
                    }
                })
        },
        limpiar() {
            this.rolByUsu.idRolXUsu = '0'
            this.rolByUsu.idRol = this.idRol
            this.rolByUsu.idUsuario = '0'
            this.rolByUsu.idApp = '1'
            this.rolByUsu.flagActivo = '1'
            this.rolByUsu.usuario = this.$session.get('user')
        },
        verAnular: function (item) {
            this.trab = { ...item }
            this.rolByUsu = { ...this.ususByRol.filter(us => us.idUsuario === this.trab.idUsuario)[0] }
            this.rolByUsu.flagActivo = '0'
            this.error.desError = ''
            //console.log('------', this.rolByUsu)
        },
        ver: function (item) {
            this.limpiar()
            this.trab = { ...item }
            this.rolByUsu.idUsuario = this.trab.idUsuario
            this.texto = 'AGREGAR TRABAJADOR'
            this.error.desError = ''
            //console.log('------', this.rolByUsu)
        },
        merge: function () {
            //this.rolByUsu.idUsuario = vidUsu
            axios.post(
                `${apiURL}/operaciones/rolByUsu/add`,
                {
                    'idRolXUsu': this.rolByUsu.idRolXUsu,
                    'idUsuario': this.rolByUsu.idUsuario,
                    'idRol': this.rolByUsu.idRol,
                    'flagActivo': this.rolByUsu.flagActivo,
                    'usuario': this.$session.get('user')
                }
            ).then(response => {
                this.error = response.data
                this.carga()
                this.limpiar()

            })
                .catch(error => {
                    if (error.response && error.response.status === 401) {
                        App.methods.logout.call(this);
                    }
                })
        },
        alertaError() {
            Swal.fire({
                icon: 'error',
                title: 'Usuario No Autorizado',
                text: 'No tienes permisos para acceder.',
                timer: 2000, // Duración en milisegundos
                timerProgressBar: true,
                showConfirmButton: false
            }).then(() => {
                // Se redirecionará a la vista anterior cuando se cierre el cuadro de diálogo.
                this.$router.push('/login');
            });
        },
        alertaError401() {
            Swal.fire({
                icon: 'error',
                title: 'La sesión ha expirado',
                //text: 'Vuelve a iniciar sesión.',
                footer: '<a href="#">Vuelve a iniciar sesión.</a>',
                timer: 3000, // Duración en milisegundos
                timerProgressBar: true,
                showConfirmButton: false
            }).then(() => {
                //this.$session.destroy()
                //this.$router.push('/login')
                App.methods.logout.call(this); ///Cierra la sesión                
            });
        },
        alertaError500() {
            Swal.fire({
                icon: 'error',
                title: 'Error interno del servidor',
                text: 'Ocurrió un error. Por favor, inténtalo de nuevo más tarde..',
                timer: 5000, // Duración en milisegundos
                timerProgressBar: true,
                showConfirmButton: false
            }).then(() => {
                // Se redirecionará a la vista anterior cuando se cierre el cuadro de diálogo.
                this.$router.push('/login');
            });
        },
    },
    beforeRouteLeave(to, from, next) {
        /*
        // Verifica si la ruta de destino NO es 'usuarios'
        if (to.name !== 'usuarios') {
            // Limpia desApp (descripción del App) antes de salir de la ruta
            localStorage.removeItem('rol_idApp');
            localStorage.removeItem('rol_nombreApp');
            localStorage.removeItem('rol_descripcionRol');
        }
        */
        localStorage.removeItem('rol_idRol')
        localStorage.removeItem('rol_descripcionRol');
        localStorage.removeItem('rol_idApp');
        localStorage.removeItem('rol_nombreApp');
        next();
    },
}
</script>

<style>
.fuente.box-title.p-t-2 {
  display: grid;
  place-items: center;
  font-weight: bold;
  font-size: 11px;
  /*text-decoration: underline;*/
}

</style>



// WEBPACK FOOTER //
// Rol_Detalle.vue?816f4950